import type { PreOrderPaymentAmount, PreOrderPaymentCredentials, PreOrderPaymentKind, ResolvedPreOrderResponse } from './types';
import { PAYMENT_CREDENTIAL_VALIDATORS, PAYMENT_INFO_ERROR, UPGRADE_PAYMENT_FIELDS } from './constants';

function normalizeCredential(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/** 验证 PC 预下单凭证并映射现有轮询参数。 */
export function resolvePreOrderPayment<T extends PreOrderPaymentCredentials>(
  commodity: T | null | undefined,
  kind: PreOrderPaymentKind
): ResolvedPreOrderResponse<T> {
  if (!commodity) throw new Error(PAYMENT_INFO_ERROR);
  const innerOrderId = normalizeCredential(commodity?.innerOrderId);
  const signNo = normalizeCredential(commodity?.signNo);
  const payment = {
    qrCode: normalizeCredential(commodity?.qrCode),
    innerOrderId,
    signNo,
    transactionId: innerOrderId,
    agreementNo: signNo
  };
  // 跳转 schema 只用于识别升级，不是二维码兜底；查询凭证按真实轮询接口校验。
  if (!payment.qrCode || !PAYMENT_CREDENTIAL_VALIDATORS[kind](payment)) {
    throw new Error(PAYMENT_INFO_ERROR);
  }
  return { ...commodity, ...payment };
}

/** 根据本次预下单响应判断是否为升级支付。 */
export function hasUpgradePayment(commodity: PreOrderPaymentCredentials | null | undefined): boolean {
  return UPGRADE_PAYMENT_FIELDS.some((field) => Boolean(normalizeCredential(commodity?.[field])));
}

/** 获取预下单实付展示金额，单位：元。 */
export function getPreOrderAmountYuan(commodity: PreOrderPaymentAmount | null | undefined): number | undefined {
  const amount = hasUpgradePayment(commodity) ? commodity?.payAmount : commodity?.totalAmount;
  return typeof amount === 'number' && Number.isFinite(amount) ? amount / 100 : undefined;
}
